export var ERR_CODE_METHOD_NOT_SUPPORT = {
  code: 'C001',
  message: '该账号不支持此方式'
};
export var ERR_CODE_MISSING_REQUIRED_ARGUMENTS = {
  code: 'C002',
  message: '缺少必要参数'
};